import type { BooleanDisplaySettingKey, IndividualSettingToggleImplementation } from '../settings';
import autoScroll from './display/autoScroll';
import darkMode from './display/darkMode';

export const toggleSettingImplementationMapping: { [K in BooleanDisplaySettingKey]: IndividualSettingToggleImplementation<K> } = {
  autoHideInterface: () => undefined,
  autoScroll,
  clickToListen: () => undefined,
  darkMode
};
